module.exports = __webpack_public_path__ + "img/logo_dy.6918800b.png";